module.exports = __webpack_public_path__ + "assets/img/BS.980afbf8.jpg";